// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toggle-group {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}
.toggle-group button {
  flex: 1;
  padding: 10px 20px;
  margin: 0;
  background-color: #d9d9d9;
  cursor: pointer;
  transition: background-color 0.3s;
  border: none;
}
.toggle-group button.active {
  background-color: #ff0059;
  color: white;
}
.toggle-group button.active:hover {
  background-color: #ff0059;
}
.toggle-group button:hover {
  background-color: #e0e0e0;
}
.toggle-group button:not(:last-child) {
  border-right: none;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
